import React, { Component } from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import _ from 'lodash';

import { MergeAttributes } from '../../components/FlatData';

import SimpleModal from '../../components/SimpleModal';
import EditAction from '../../components/EditAction';
import DeleteAction from '../../components/DeleteAction';

import UserForm from '../../components/manage_users/users/UserForm';
import UserStore from '../../stores/UserStore';
import Loading from '../../components/Loading';
import AfterSaveLoading from '../../components/AfterSaveLoading';

class UserPage extends Component {
	constructor(props) {
		super(props)

		this.state = {
			open: false,
			editingId: '',
			users: [],
			isDataFetched: false,
			pagination: {},
      searchText: '',
			loading: false
		}

		this.handleNew = this.handleNew.bind(this);
		this.actionsFormatter = this.actionsFormatter.bind(this);
		this.positionFormat = this.positionFormat.bind(this);
		this.fullnameFormat = this.fullnameFormat.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.reloadData = this.reloadData.bind(this);
		this.handleCloseAndReloadData = this.handleCloseAndReloadData.bind(this);

		// Pagination
		this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
	}

	componentWillMount() {
		this.reloadData();
	}

	reloadData(){
    const active_page = this.state.pagination.active_page || 1;
    const { searchText } = this.state;

		UserStore.request({url: `users?page=${active_page}&searchText=${searchText}`}).then((resp)=>{
			const users = _.get(resp.data, 'data', []);
			const pagination = _.get(resp.data, 'meta.pagination', {});

			this.setState({
				users: users,
				pagination: pagination
			})
		}).then(()=>{
			this.setState({isDataFetched: true, loading: false});
		})
	}

	handleNew(){
		this.setState({
			editingId: '',
			open: true
		})
	}

	handleEdit(id){
		this.setState({
			editingId: id,
			open: true
		})
	}

	handleDelete(id){
		if (window.confirm(`Would you like to delete this user?`)){
			this.setState({loading: true});

			UserStore.request({id: id, method: 'delete'}).then(()=>{
				this.reloadData();
			})
		}
	}

	actionsFormatter(cell, row) {
	  	return (
	  		<div>
	  			<EditAction id={ cell } onEdit={this.handleEdit.bind(this, cell)}/>&ensp;
	  			<DeleteAction id={ cell } onDelete={this.handleDelete.bind(this, cell)}/>
	  		</div>
	  	)
	}

	positionFormat(cell, row){
		return (
			<div style={{whiteSpace: 'normal'}}>{row.position_names}</div>
		)
	}

	fullnameFormat(cell, row){
		return (
			<div style={{whiteSpace: 'normal'}}>{row.full_name}</div>
		)
	}

	handleClose(){
		this.setState({open: false, editingId: ''})
	}

	handleCloseAndReloadData(){
		this.setState({loading: true});
		this.setState({open: false, editingId: ''}, this.reloadData());
	}

	_setTableOption(){ 
     	if(this.state.isDataFetched){
           	return "Not found";
      	}else{
            return <Loading />
      	}
	}

  handlePageChange(page, sizePerPage){
    this.setState({isDataFetched: false, users: []});
    const { searchText } = this.state;

    UserStore.request({url: `users?page=${page}&searchText=${searchText}`}).then((resp)=>{
      const users = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        users: users,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  handleSearchChange(searchText){
    if (searchText.length === 1) { return }
    this.setState({isDataFetched: false, users: []});

    UserStore.request({url: `users?page=1&searchText=${searchText}`}).then((resp)=>{
      const users = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        users: users,
        pagination: pagination,
        searchText: searchText
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

	render(){
		var title_modal = 'Create User'
		if (!_.isEmpty(this.state.editingId)){
			title_modal = 'Edit User'
		}

		const total_items_count = _.get(this.state.pagination, 'total_items_count', 0);
    const active_page = _.get(this.state.pagination, 'active_page', 1);
		const options = {
			noDataText: this._setTableOption(),
    	sizePerPageList: [],
    	sizePerPage: 10,
      page: active_page,
      onPageChange: this.handlePageChange,
      onSearchChange: this.handleSearchChange,
      searchDelayTime: 500
    };
		var data = MergeAttributes(this.state.users);

		return (
		  <div>
		  	{this.state.loading && <AfterSaveLoading />}
		  	
			<div className='row'>
			  <div className='col-md-6'>
				<h4>Users</h4>
			  </div>
			  <div className='col-md-6 text-right'>
				<button type='button' 
					className='btn btn-success'
					onClick={this.handleNew}>+ Create User</button>
			  </div>
			</div>

			<BootstrapTable 
			  data={data}
			  remote={ true }
        fetchInfo={{dataTotalSize: total_items_count}}
			  search={ true }
			  multiColumnSearch={ true }
			  options={options}
			  striped
			  hover
			  pagination
			  version='4'
			  tableContainerClass={'table-sm'}>
			  <TableHeaderColumn isKey dataField='code' dataSort={ true } width='120px' columnClassName='text-center'>Code</TableHeaderColumn>
			  <TableHeaderColumn dataField='full_name' dataSort={ true } dataFormat={this.fullnameFormat}>Fullname</TableHeaderColumn>
			  <TableHeaderColumn dataField='username' dataSort={ true }>Uername</TableHeaderColumn>
			  <TableHeaderColumn dataField='email' dataSort={ true }>Email</TableHeaderColumn>
			  <TableHeaderColumn dataField='position_names' dataSort={ true } dataFormat={this.positionFormat}>Position(s)</TableHeaderColumn>
			  <TableHeaderColumn dataField='id' dataFormat={ this.actionsFormatter } columnClassName='text-center'></TableHeaderColumn>
			</BootstrapTable>

			<SimpleModal 
				isOpen={this.state.open}
				title={title_modal}
				showSubmitButton={false}
				onClose={this.handleClose}>
				<UserForm 
					{...this.state} 
					onClose={this.handleClose} 
					onCloseAndReloadData={this.handleCloseAndReloadData} />
			</SimpleModal>
		  </div>
		);
	}
}

export default UserPage;


// WEBPACK FOOTER //
// ./src/pages/manage_users/UserPage.js